/**
 * @generated SignedSource<<3df847d8476629039b7d5363b0666e6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaseIndividualModalDeleteMutation$variables = {
  id: string;
};
export type CaseIndividualModalDeleteMutation$data = {
  readonly softDelete: {
    readonly success: boolean | null;
  } | null;
};
export type CaseIndividualModalDeleteMutation = {
  response: CaseIndividualModalDeleteMutation$data;
  variables: CaseIndividualModalDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SoftDelete",
    "kind": "LinkedField",
    "name": "softDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CaseIndividualModalDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CaseIndividualModalDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b16235ed2478099bca345ef72db64734",
    "id": null,
    "metadata": {},
    "name": "CaseIndividualModalDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CaseIndividualModalDeleteMutation(\n  $id: ID!\n) {\n  softDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "c33db9451f5eba93a67abae66d82a6fe";

export default node;
